const DEFAULT_EXPECTED_STATUS_CODES = [400, 401, 403, 404];

export function isExpectedApiError(err, expectedStatusCodes = DEFAULT_EXPECTED_STATUS_CODES) {
  const status = err?.response?.status;
  return expectedStatusCodes.includes(status);
}

export function logUnexpectedApiError(context, err, expectedStatusCodes = DEFAULT_EXPECTED_STATUS_CODES) {
  if (!isExpectedApiError(err, expectedStatusCodes)) {
    console.warn(context, err);
  }
}
